import { FC } from 'react';
import { useOnAuth } from '../../auth/useOnAuth';

export const Login: FC = () => {
  useOnAuth(false);
  return <></>;
};
